
@if (widget.component == 'card') {
  <app-widget-card class="{{widget.className}}" [selection]="selection" [item]="widget">
  </app-widget-card>
}
<!-- <ng-container *ngIf="wizard.component == 'chart'">

<dhs-chart [chartDataSets]="lineChartData" [chartLabels]="lineChartLabels" [chartOptions]="lineChartOptions"
  [chartColors]="lineChartColors" [chartLegend]="lineChartLegend" [chartType]="lineChartType"
[chartPlugins]="lineChartPlugins" class="{{wizard.className}}"></dhs-chart>
</ng-container> -->
@if (widget.component == 'groupchart') {
  <app-chart-group class="{{widget.className}}" [selection]="selection" [item]="widget"></app-chart-group>
}

@if (widget.component == 'doughnut') {
  <app-chart-doughnut class="{{widget.className}}" [selection]="selection" [item]="widget"></app-chart-doughnut>
}